
/**
 *      Data-driven UI that displays the common data model
 *
 *      @author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *      Created on 09/22/2017
 *      Modified on 09/20/2018
 */


var makingAjaxRequest = false;
/**
 * Fetch Common Data Model from DMR
 * @param type {string} - model name
 * @return {boolean} - CDM model found flag
 */
function getCDMView( type ) {
    var model,
        url,
        found = false;
    if ( type ) {
        // check if CDM model exists already
        model = getCommonDataModel( type );
        if ( ! model ) {
            url = "/dmr/api/v1/" + type + "/cdm";
            makingAjaxRequest = true;
            makeAjaxRequest( url, commonDataModelFound( type ), dataNotFound( url ) );
        } else {
            found = true;
        }
    }
    return found;
}

/**
 * Returns a JSON Common Data Model from the Data Model Registry
 * @param type {string} - data type
 * @param successCallback {Function} - function that gets called on success
 * @param failureCallback {Function} - function that gets called on failure
 */

function getCDMModel( type, successCallback, failureCallback ) {
    var url;
    if ( type ) {
        url = "/dmr/api/v1/" + type + "/cdm";
        makeAjaxRequest( url, successCallback, failureCallback );
    }
}


/**
 * Return a function that displays the button to CDM view
 * @returns {Function}
 */
function commonDataModelFound( type ) {

    /**
     * Callback that is called when the call to fetch the common data model succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {

        makingAjaxRequest = false;
        if ( data ) {
            // save common data model
            saveCommonDataModel( type, data );
            // display CDM button
            displayViewButton( "cdm" );
        }
    };
}

/**
 * Retrieve a common data model from the global page state if it exists
 * @param name {string} - data type name
 * @returns {object}
 */
function getCommonDataModel( name ) {
    var model;
    if ( name ) {

        if ( ! GlobalPageState ) {
            GlobalPageState = {};
        }
        if ( ! GlobalPageState.cdm ) {
            GlobalPageState.cdm = {};
        }

        if ( GlobalPageState && GlobalPageState.cdm ) {
            model = GlobalPageState.cdm[ name ];
        }
    }
    return model;
}

/**
 * Save a JSON common data model to the global page state
 * @param name {string} - data type
 * @param model {object} - JSON data model
 */
function saveCommonDataModel( name, model ) {

    if ( ! GlobalPageState ) {
        GlobalPageState = {};
    }
    if ( ! GlobalPageState.cdm ) {
        GlobalPageState.cdm = {};
    }

    if ( GlobalPageState.cdm && ! GlobalPageState.cdm[ name ] && model !== undefined ) {
        GlobalPageState.cdm[ name ] = model;
    }
}

/**
 * Display model view button
 * @param view {string} - data view name ("edi" or "cdm")
 */
function displayViewButton( view ) {

    var headerRegion,
        headerView,
        headerModel;

    if ( GlobalPageState && GlobalPageState.layout ) {
        headerRegion = GlobalPageState.layout.getRegion( "headerRegion" );
        if ( headerRegion ) {

            headerView = headerRegion.currentView;

            if ( headerView && view ) {
                headerModel = headerView.model;

                // set the view flag in the region model
                // the headerModel flag signifies what button to show, which is the opposite of the data shown
                if ( view !== "edi" ) {
                    headerModel.set("edi", false);
                } else {
                    headerModel.set("cdm", false);
                }
                headerModel.set( view, true );

                // re-render header region with updated model
                headerView.render();
            }
        }
    }

}

/**
 * Hide model view button
 * @param view {string} - data view name ("edi" or "cdm")
 */
function hideViewButton( view ) {
    var headerRegion,
        headerView,
        headerModel;

    if ( GlobalPageState && GlobalPageState.layout ) {
        headerRegion = GlobalPageState.layout.getRegion( "headerRegion" );

        if ( headerRegion ) {
            headerView = headerRegion.currentView;
            if ( headerView ) {
                headerModel = headerView.model;

                if ( headerModel ) {
                    // Set the view flag to false
                    headerModel.set( view, false );

                    // Re-render the view with updated model
                    headerView.render();
                }
            }
        }
    }
}

/**
 * Show record region view with new data model
 * @param viewToShow {string} - data view name ("edi" or "cdm")
 * @param viewToHide {string} - data view name ("edi" or "cdm")
 */
function showDataView( viewToShow, viewToHide ) {

    var layoutView,
        data,
        type,
        models,
        jsonModel,
        regions,
        regionsToRender = [],
        regionNames,
        region,
        regionLayout,
        i,
        j,
        k;

    if ( GlobalPageState && GlobalPageState.cdm ) {

        layoutView = GlobalPageState.layout;
        data = GlobalPageState.data;
        type = GlobalPageState.type;

        if ( type && viewToShow ) {

            // Get data models from the global store
            if ( viewToShow === "edi") {
                models = GlobalPageState.models;
            } else {
                models = GlobalPageState[ viewToShow ];
            }

            if ( models && layoutView ) {
                jsonModel = models[ type ];

                if ( jsonModel ) {
                    regions = getViewRegions( );
                    regionNames = getRegionNames();
                    if ( regions && regionNames ) {

                        for ( i = 0; i < regions.length; i++ ) {
                            for ( j = 0; j < regionNames.length; j++ ) {
                                if ( regions[i].name === regionNames[j] ) {
                                    regionsToRender.push( regions[ i ] );
                                }
                            }
                        }

                        // Reset metadata regions
                        for ( k = 0; k < regionNames.length; k++ ) {
                            // Reset region (remove all rendered data)
                            clearRegion( layoutView, regionNames[ k ] );
                        }

                        // Display metadata with common data model
                        for ( k = 0; k < regionsToRender.length; k++ ) {
                            // For non-default view, return the layout and show the data
                            // Default view, renders the data without returning
                            regionLayout = getRegionLayout( regionsToRender[ k ], data, layoutView, jsonModel );

                            if ( regionLayout ) {
                                region = layoutView.getRegion( regionsToRender[k].name );
                                if ( region ) {
                                    region.show( regionLayout );
                                }
                            }
                        }

                        // Hide View button
                        hideViewButton( viewToShow );

                        // Set global view variable
                        GlobalPageState.view = viewToShow;

                        // Show View model button
                        displayViewButton( viewToHide );

                        // Expand first accordion if global graph collapse flag is true
                        if ( GlobalPageState.collapse ) {
                            expandFirstAccordion( );
                        }
                    }
                }
            }
        }
    }
}

/**
 * Get all of the view regions
 * @return {[object]}
 */
function getViewRegions( ) {

    var propertiesArray,
        properties,
        regions,
        viewModel = RecordViewModel; // Default single record view model

    // Check the type of the record
    if ( GlobalPageState ) {
        if ( GlobalPageState.type === "component" || GlobalPageState.type === "emucomponent" ) {
            viewModel = ComponentViewModel;
        }
        else if ( GlobalPageState.type === "part" || GlobalPageState.type === "emupart" ) {
            viewModel = PartViewModel;
        }
    }

    if ( viewModel ) {
        propertiesArray = viewModel.properties;
        if ( propertiesArray && propertiesArray.length === 1 ) {
            properties = propertiesArray[ 0 ];
            if ( properties ) {
                regions = properties.regions;
            }
        }
    }

    return regions;
}

/**
 * Get metadata region names
 * @return {[string]}
 */
function getRegionNames() {

    var regionNames = [ ];

    if ( GlobalPageState ) {
        if ( GlobalPageState.type === "component" || GlobalPageState.type === "emucomponent" || GlobalPageState.type === "part" || GlobalPageState.type === "emupart" ) {
            regionNames.push( "accordionRegionGeneral" );
            regionNames.push( "accordionRegionAttributes" );
            regionNames.push( "accordionRegionLimitedLife" );
        }
        else {
            // Default region name
            regionNames.push( "recordRegion" );
        }
    }

    return regionNames;
}

/**
 * Clear data from the region and the DOM
 * @param layoutView {object} - page layout
 * @param regionName {string} - region name
 */
function clearRegion( layoutView, regionName ) {

    var regionView,
        el;

    if ( regionName ) {

        regionView = layoutView.getRegion( regionName );

        if ( regionView ) {
            // empty previously rendered region
            regionView.reset();

            // Get DOM is of the region from the region object
            el = regionView.el;
            if ( el ) {
                $( el ).empty();
            }
        }
    }
}
